var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10C18.8137 10 21.5 12.6863 21.5 16C21.5 19.3137 18.8137 22 15.5 22C12.1863 22 9.5 19.3137 9.5 16C9.5 12.6863 12.1863 10 15.5 10ZM9.09766 12.0938C8.40194 13.2316 8 14.5687 8 16C8 17.0669 8.22439 18.0811 8.62598 19H3.50195C2.94878 19 2.5 18.5582 2.5 18.0137C2.50011 14.7434 5.19151 12.094 8.51367 12.0938H9.09766ZM16.3457 13.1943C16.0744 12.9358 15.6278 12.9358 15.3564 13.1943C15.0856 13.4528 15.0856 13.8773 15.3564 14.1357L16.6123 15.333H12.7002C12.3151 15.333 12 15.6331 12 16C12 16.3669 12.3151 16.667 12.7002 16.667H16.6123L15.3564 17.8643C15.0856 18.1227 15.0856 18.5472 15.3564 18.8057C15.6278 19.0642 16.0744 19.0642 16.3457 18.8057L18.7969 16.4707C19.0676 16.2123 19.0676 15.7877 18.7969 15.5293L16.3457 13.1943ZM10.0557 2C11.2007 2.00003 12.2987 2.44811 13.1084 3.24512C13.918 4.04213 14.373 5.12289 14.373 6.25C14.373 7.15879 14.076 8.03661 13.5371 8.76074C12.3571 9.07993 11.2921 9.67876 10.4189 10.4834C10.2985 10.4934 10.1774 10.5 10.0557 10.5C8.9106 10.5 7.81261 10.0519 7.00293 9.25488C6.19326 8.45785 5.73828 7.37716 5.73828 6.25C5.73828 5.12284 6.19326 4.04215 7.00293 3.24512C7.81261 2.44809 8.9106 2 10.0557 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco12);
export default __webpack_public_path__ + "static/media/Gnb_ico_12.63ee5335ceaa747de3f1528631236f55.svg";
export { ForwardRef as ReactComponent };